import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.ProductTabService = function () {

};

HSN.Service.ProductTabService.prototype =
{

    GetProductReviews: function (encodedProductName, id, page, recordsPerPage, sortTerm,
                                    sortSequence, pfid, ratingFilter, percentRecommended, source, lessman, config) {
        if(!id) {
            return;
        }

        config.isCacheable = true;
        this._sendHtml("/products/productreviews/get-product-reviews", {
            encodedProductName: encodedProductName,
            id: id,
            page: page,
            recordsPerPage: recordsPerPage,
            sortTerm: sortTerm,
            sortSequence: sortSequence,
            sku: pfid,
            ratingFilter: ratingFilter,
            percentRecommended: percentRecommended,
            source: source,
            lessman: lessman
        }, config);
    },

    GetProductTab: function (id, tab, config) {
        if(!id || !tab) {
            return;
        }
        config.isCacheable = true;
        this._sendHtml("/products/producttab/get-product-tab", { id: id, tab: tab }, config);
    },

    _sendHtml: function (url, data, config) {
        config = (config = config || {});

        if (!config.isCacheable) {
            if (typeof data === 'string') {
                var joiner = data.indexOf("=") === -1 ? "" : "&";
                data += joiner + "_ts=" + new Date().getTime();
            } else {
                data['_ts'] = new Date().getTime();
            }
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), true, data);
                },
                error: function (xhr, status, error) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), false, error);
                }
            }
        );
    },

    _sendJson: function (url, data, config) {
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function (data, status, xhr) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), data.success);
                },
                error: function (xhr, status, error) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), error);
                }
            }
        );
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Service/ProductTabService.js